import './Button.css'
import { IoIosSave } from 'react-icons/io'
import { FaFileCirclePlus } from 'react-icons/fa6'
import { FiXCircle, FiTrash2, FiEdit2, FiCheckCircle, FiMapPin, FiPrinter, FiTag } from 'react-icons/fi'
import { MdOutlineAddTask } from 'react-icons/md'
import { GrDocumentConfig } from 'react-icons/gr'

const VARIANTS = {
    save: { cls: 'btn-flat btn-flat-save', Icon: IoIosSave },
    new: { cls: 'btn-flat btn-flat-new', Icon: FaFileCirclePlus },
    cancel: { cls: 'btn-flat btn-flat-cancel', Icon: FiXCircle },
    delete: { cls: 'btn-flat btn-flat-delete', Icon: FiTrash2 },
    edit: { cls: 'btn-flat btn-flat-edit', Icon: FiEdit2 },
    finish: { cls: 'btn-flat btn-flat-finish', Icon: FiCheckCircle },
    select: { cls: 'btn-flat btn-flat-select', Icon: MdOutlineAddTask },
    map: { cls: 'btn-flat btn-flat-map', Icon: FiMapPin },
    config: { cls: 'btn-flat btn-flat-config', Icon: GrDocumentConfig },
    print: { cls: 'btn-flat btn-flat-print', Icon: FiPrinter },
    muted: { cls: 'btn-flat btn-flat-muted', Icon: FiTag },
}

function Button({ variant = 'save', type = 'button', onClick, children, className, style, icon: IconOverride, disabled, form }) {
    const { cls, Icon } = VARIANTS[variant] || VARIANTS.save
    const FinalIcon = IconOverride || Icon
    return (
        <button
            type={type}
            form={form}
            className={`shd-bt-m-1 ${cls} ${className || ''}`}
            style={{ margin: 0, ...style }}
            onClick={onClick}
            disabled={disabled}
        >
            <span className="btn-icon"><FinalIcon /></span>
            <span className="btn-label"><span className="btn-label-text">{children}</span></span>
        </button>
    )
}

export default Button
